import {Sound} from '../../../../shared/scripts/Sound'
import {UIUtilsEjsVariables} from '../../../../shared/scripts/UIUtilsEjsVariables'
import {UIWHeaderCoinController} from './UIWHeaderCoinController'
import {ClientUserState} from '../../../../shared/scripts/ClientUserState'

export class UIDHeaderCoinController extends UIWHeaderCoinController {
    private readonly visitStoreCallback: () => void

    constructor(visitStoreCallback: () => void) {
        super()
        this.setCoinHeaderVisibility()
        this.visitStoreCallback = visitStoreCallback
    }

    override registerOnClickListenerForStore() {
        this.headerCoinsContainer.onclick = () => {
            Sound.playSound(Sound.SoundType.Click)

            this.visitStoreCallback()
            const coinSection = document.getElementById('coins')
            coinSection?.scrollIntoView({behavior: 'smooth'})
        }
    }

    private setCoinHeaderVisibility() {
        ClientUserState.registerChangeListener((userState) => {
            if(userState == undefined) return
            this.headerCoinsContainer.hidden = !UIDHeaderCoinController.shouldShowCoinHeader(userState.forceSubscription)
        })
    }

    private static shouldShowCoinHeader(forceSubscription: boolean): boolean {
        if(UIUtilsEjsVariables.canPurchaseCoinsOnDiscord) return true
        if(forceSubscription == false) return true
        return false
    }
}
